import { forwardRef } from 'react';

import { Button, ButtonProps } from '@/components/ui/button/button';

export const IconButton = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      isIconOnly = true,
      disableRipple = true,
      disableAnimation = true,
      variant = 'light',
      size = 'sm',
      ...rest
    },
    ref,
  ) => {
    return (
      <Button
        ref={ref}
        isIconOnly={isIconOnly}
        disableRipple={disableRipple}
        disableAnimation={disableAnimation}
        variant={variant}
        size={size}
        className="text-md"
        {...rest}
      />
    );
  },
);

IconButton.displayName = 'IconButton';
